module.exports = __webpack_public_path__ + "static/media/demo-14.85ee0f23.jpg";